import React from "react";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { FormControl, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import PropTypes from "prop-types";
import { jobPositionActions, postJobPosition } from "../../../../redux/reducer/jobPosition/jobPositionReducer";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AdminJobPositionTambah({ open, handleClose }) {
  // State
  const [formData, setFormData] = useState({
    positionName: "",
  });

  // Redux
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      token: token,
      data: formData,
    };
    Swal.fire({
      title: `Periksa kembali data yang akan ditambahkan`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        dispatch(postJobPosition(data)).then((res) => {
          if (res.payload.status === 201) {
            toast.success(res.payload.message);
            dispatch(jobPositionActions.addJobPosition(res.payload.data));
            setFormData({
              positionName: "",
            });
            handleClose();
          } else {
            toast.error(res.payload.message);
          }
        });
      } else {
        setFormData({
          positionName: "",
        });
      }
    });
  };

  return (
    <>
      <ToastContainer />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"TAMBAH DATA JABATAN"}</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent style={{ padding: "5px 24px" }}>
            <FormControl>
              <TextField
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                required
                inputProps={{ maxLength: 15 }}
                size="small"
                error={false}
                label="NAMA JABATAN"
                value={formData.positionName}
                name="positionName"
                fullWidth
                variant="standard"
                style={{ width: "90vw", maxWidth: "400px" }}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Submit</Button>
            <Button onClick={handleClose} color="error">
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

AdminJobPositionTambah.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};
